export default __webpack_public_path__ + "static/media/group.d4052d34.svg";